<template>
  <div v-if="showAdminWarning" class="p-16 bg-bg-warning text-text-warning type-sm">
    This component is not available on corporate domains
  </div>
  <div
    v-else-if="!isNonEcomSite"
    ref="hotSpotBlockRef"
    v-editable="blok"
    class="HotSpotBlock layout-container"
    :class="[desktopWidth('full'), blockPaddingTop('md'), blockPaddingBottom('md')]"
  >
    <div v-if="hotSpotContent[0]">
      <!--- **** Layout Default **** --->
      <div v-if="blok.layout === 'default'" class="grid grid-cols-2 desk:grid-cols-4 gap-8">
        <div class="col-span-1 flex flex-col gap-8">
          <div class="AspectLandscape relative aspect-landscape">
            <div v-if="hotSpotContent[0]">
              <HotSpotImage
                v-if="hotSpotContent[0]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[0]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[0]"
              />
            </div>
          </div>
          <div class="AspectPortrait aspect-portrait">
            <div v-if="hotSpotContent[1]">
              <HotSpotImage
                v-if="hotSpotContent[1]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[1]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[1]"
              />
            </div>
          </div>
        </div>
        <div class="col-span-1 flex flex-col gap-8">
          <div class="AspectPortrait relative aspect-portrait">
            <div v-if="hotSpotContent[2]">
              <HotSpotImage
                v-if="hotSpotContent[2]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[2]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[2]"
              />
            </div>
          </div>
          <div class="AspectLandscape relative aspect-landscape">
            <div v-if="hotSpotContent[3]">
              <HotSpotImage
                v-if="hotSpotContent[3]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[3]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[3]"
              />
            </div>
          </div>
        </div>
        <div class="col-span-2 flex flex-col gap-8">
          <div class="AspectSquare aspect-square">
            <div v-if="hotSpotContent[4]">
              <HotSpotImage
                v-if="hotSpotContent[4]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[4]"
                :products="products"
                img-size="lg"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[4]"
              />
            </div>
          </div>
        </div>
      </div>

      <!--- **** Layout Reversed **** --->
      <div v-if="blok.layout === 'reversed'" class="grid grid-cols-2 desk:grid-cols-4 gap-8">
        <div class="col-span-2 flex flex-col gap-8">
          <div class="AspectSquare aspect-square">
            <div v-if="hotSpotContent[0]">
              <HotSpotImage
                v-if="hotSpotContent[0]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[0]"
                :products="products"
                img-size="lg"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[0]"
              />
            </div>
          </div>
        </div>
        <div class="col-span-1 flex flex-col gap-8">
          <div class="AspectLandscape relative aspect-landscape">
            <div v-if="hotSpotContent[1]">
              <HotSpotImage
                v-if="hotSpotContent[1]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[1]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[1]"
              />
            </div>
          </div>
          <div class="AspectPortrait aspect-portrait">
            <div v-if="hotSpotContent[2]">
              <HotSpotImage
                v-if="hotSpotContent[2]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[2]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[2]"
              />
            </div>
          </div>
        </div>
        <div class="col-span-1 flex flex-col gap-8">
          <div class="AspectPortrait relative aspect-portrait">
            <div v-if="hotSpotContent[3]">
              <HotSpotImage
                v-if="hotSpotContent[3]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[3]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[3]"
              />
            </div>
          </div>
          <div class="AspectLandscape relative aspect-landscape">
            <div v-if="hotSpotContent[4]">
              <HotSpotImage
                v-if="hotSpotContent[4]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[4]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[4]"
              />
            </div>
          </div>
        </div>
      </div>

      <!--- **** Layout Four Columns **** --->
      <div v-if="blok.layout === 'four-columns'" class="grid grid-cols-2 desk:grid-cols-4 gap-8">
        <div class="col-span-1 flex flex-col gap-8">
          <div class="AspectLandscape relative aspect-landscape">
            <div v-if="hotSpotContent[0]">
              <HotSpotImage
                v-if="hotSpotContent[0]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[0]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[0]"
              />
            </div>
          </div>
          <div class="AspectPortrait relative aspect-portrait">
            <div v-if="hotSpotContent[1]">
              <HotSpotImage
                v-if="hotSpotContent[1]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[1]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[1]"
              />
            </div>
          </div>
        </div>
        <div class="col-span-1 flex flex-col gap-8">
          <div class="AspectPortrait relative aspect-portrait">
            <div v-if="hotSpotContent[2]">
              <HotSpotImage
                v-if="hotSpotContent[2]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[2]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[2]"
              />
            </div>
          </div>
          <div class="AspectLandscape relative aspect-landscape">
            <div v-if="hotSpotContent[3]">
              <HotSpotImage
                v-if="hotSpotContent[3]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[3]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[3]"
              />
            </div>
          </div>
        </div>
        <div class="col-span-1 flex flex-col gap-8">
          <div class="AspectLandscape relative aspect-landscape">
            <div v-if="hotSpotContent[4]">
              <HotSpotImage
                v-if="hotSpotContent[4]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[4]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[4]"
              />
            </div>
          </div>
          <div class="AspectPortrait relative aspect-portrait">
            <div v-if="hotSpotContent[5]">
              <HotSpotImage
                v-if="hotSpotContent[5]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[5]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[5]"
              />
            </div>
          </div>
        </div>
        <div class="col-span-1 flex flex-col gap-8">
          <div class="AspectPortrait relative aspect-portrait">
            <div v-if="hotSpotContent[6]">
              <HotSpotImage
                v-if="hotSpotContent[6]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[6]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[6]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="flex items-center justify-center p-24">
      Add Hot Spot Content
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import useVisualAppearancePlugin from '~/composables/useVisualAppearancePlugin';
import HotSpotText from '~/components/hotspot/HotSpotText.vue';
import HotSpotImage from '~/components/hotspot/HotSpotImage.vue';
import useStoryblokAdmin from '~/composables/useStoryblokAdmin';
import useAlgoliaFetch from '~/composables/useAlgoliaFetch';
import type { ProductSelector } from '#constants/types/storyblok';
import type { ProductModel } from '#models/product';

const { isNonEcomSite, showAdminWarning } = useNonEcomGuard();

type HotSpotBlockType = {
  _uid: string;
  title: string;
  hotSpotContent?: any[];
  layout: 'default' | 'reversed' | 'four-columns';
}

const props = defineProps<{ blok: HotSpotBlockType }>();
const hotSpotContent = computed(() => props.blok.hotSpotContent || []);

const { desktopWidth, blockPaddingTop, blockPaddingBottom } = useVisualAppearancePlugin(props);

const { isInStoryblokAdmin } = useStoryblokAdmin();
const { getProductsByPartNo, convertRawToProducts } = useAlgoliaFetch();

const products = ref<ProductModel[]>([]);
const hotSpotBlockRef = ref<HTMLElement | null>(null);
const hasLoaded = ref(false);
const isLoading = ref(false);
let observer: IntersectionObserver | null = null;

const productPartNos = computed(() => {
  return hotSpotContent.value
    .filter((item) => item?.component === 'HotSpotImage')
    .flatMap((item) => item.hotSpots || [])
    .flatMap((hotSpot: { product?: ProductSelector[] }) => hotSpot.product || [])
    .filter((prodSelector) => prodSelector.product !== '')
    .map((prodSelector) => prodSelector.product.product.partNo)
    .filter((partNo) => partNo !== '');
});

const getProducts = async() => {
  const uniquePartNos = Array.from(new Set(productPartNos.value));
  if (!uniquePartNos.length) {
    products.value = [];
    return;
  }

  const res = await getProductsByPartNo(uniquePartNos);
  if (res) {
    const splitProducts = convertRawToProducts(res.hits);
    products.value = splitProducts.map((m) => m.product);
  } else {
    console.log('@todo handle error');
  }
};

const startLoading = async() => {
  if (hasLoaded.value || isLoading.value) {
    return;
  }
  isLoading.value = true;
  await getProducts();
  hasLoaded.value = true;
  isLoading.value = false;
};

if (isInStoryblokAdmin()) {
  watch(productPartNos, async() => {
    if (!hasLoaded.value) {
      return;
    }
    await getProducts();
  });
}

onMounted(() => {
  if (!hotSpotBlockRef.value) {
    return;
  }
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        startLoading();
        observer?.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    threshold: 0.1,
  });
  observer.observe(hotSpotBlockRef.value);
});

onBeforeUnmount(() => {
  if (observer && hotSpotBlockRef.value) {
    observer.unobserve(hotSpotBlockRef.value);
  }
  observer = null;
});
</script>

<style scoped lang="postcss">
:deep(.AspectLandscape .HotSpotImageWrap, .HotSpotTextWrap) {
  @apply aspect-landscape;
}
:deep(.AspectPortrait .HotSpotImageWrap, .HotSpotTextWrap) {
  @apply aspect-portrait;
}
:deep(.AspectSquare .HotSpotImageWrap, .HotSpotTextWrap) {
  @apply aspect-square;
}
</style>
